<template>
    <div v-if="DataValues.IsPickList">
        <div class="d-flex align-items-center pt-3 pb-3 navbar">
            <BacktoPage :goback="$router.back"></BacktoPage>
            <div class="d-flex align-items-start  ps-5">
                <div class="main-header-store">{{ DataValues.StoreType }}</div>
                <div>
                    <p class="common-heading1 pt-1">{{ DataValues.StoreName }}</p>
                </div>
            </div>

            <div class="d-flex align-items-center">
                <div class="store">
                    <p class="common-heading1">{{ DataValues.TotalSelected }}</p>
                    <p class="storecode">{{ $t('PickList.selected') }}</p>
                </div>
                <div class="ps-5" v-if="PrintButtonFlag">
                    <Save icon=" pi pi-print print-button" label="Print" size="lg" @savebtn="PrintOnClick">
                    </Save>
                </div>
            </div>
        </div>
        <div class="categories-view">
            <div class="body-heading d-flex justify-content-center mt-5">
                <p>{{ $t('PickList.choose') }}</p>
            </div>
            <div class="categories">
                <div class=" d-flex justify-content-center flex-wrap">
                    <div v-for="item in CategoryList"
                        :class="['category-name', item.bgColor, { disableclass: DataValues.Disabled === 'true' }, DataValues.Disabled]"
                        @click="SelectCategories(item)">
                        {{ item["ItemCategory1"] }}
                        <span class="storecode">({{ item["count"] }})</span>
                    </div>

                </div>
            </div>
        </div>

        <b-container>
            <!-- <div v-for="item in selectedProduct" :key="item.Id">
                <p>ItemName:{{ item.ItemName }}
                    disabled :{{ item.disabled }}
                </p>
            </div> -->

            <div class="table">
                <Tableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                    v-model:value="items" v-model:selection="selectedProduct" :selectionMode="true"
                    @update:selection="ProductSelection" :CheckDisabled="DataValues.Disabled"
                    @updatedata="Itemschanges">

                    <template v-slot:filter>
                        <i class="pi pi-filter tablefilter ms-3 me-3"></i>
                    </template>
                    <template v-slot:Itemname1="{ data }">
                        <span :style="getColorStyle(data)" :title="data.Itemname1">
                            {{ data.Itemname1 }}
                        </span>
                    </template>
                    <template v-slot:Brandmodelsize="{ data }">
                        <span>
                            <template v-if="data.BrandName">{{ data.BrandName }}</template>
                            <template v-if="data.BrandName && data.ModelNumberName">/</template>
                            <template v-if="data.ModelNumberName">{{ data.ModelNumberName }}</template>
                            <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
                            <template v-if="data.SizeName">{{ data.SizeName }}</template>
                        </span>
                    </template>
                    <template v-slot:UOMName="{ data }">
                        {{
                            data.UOMName == "" || data.UOMName == null
                                ? "-"
                                : data.UOMName
                        }}
                    </template>
                    <template v-slot:StockInHand="{ data }">
                        {{
                            data.StockInHand
                        }}
                    </template>

                    <template v-slot:BatchNo="{ data }">
                        {{
                            data.BatchNo == "" || data.BatchNo == null
                                ? "-"
                                : data.BatchNo
                        }}
                    </template>
                    <template v-slot:ExpiryDate="{ data }">
                        {{
                            data.ExpiryDate == "01-01-0001" || data.ExpiryDate == "01-01-1900"
                                ? "-"
                                : data.ExpiryDate
                        }}
                    </template>
                    <template v-slot:BinLocation="{ data }">
                        {{
                            ((data.RoomName != null && data.RoomName != "") && (data.RackName != null && data.RackName !=
                                "") && (data.RowName != null && data.RowName != "") && (data.BoxName != null && data.BoxName !=
                                    "")) ? data.RoomName + "/" + data.RackName + "/" + data.RowName + "/" + data.BoxName :
                                ((data.RoomName != null && data.RoomName != "") && (data.RackName != null && data.RackName !=
                                    "") && (data.RowName != null && data.RowName != "")) ? data.RoomName + "/" + data.RackName + "/"
                                + data.RowName :
                                    ((data.RoomName != null && data.RoomName != "") && (data.RackName != null && data.RackName !=
                                        "")) ? data.RoomName + "/" + data.RackName :
                                        ((data.RoomName != null && data.RoomName != "")) ? data.RoomName :
                                            "-"
                        }}
                    </template>
                    <template v-slot:PickQty="{ data, rowIndex }">
                        <div class="label-d-none tablefield mb-0">
                            <InputText :rules="{ required: false }" :required-icon="false"
                                :name="`'PickQuantity'${rowIndex}`" :id="`'PickQuantity'${rowIndex}`"
                                :class="{ disableclass: data.disabled == true }" v-model="data.PickQuantity"
                                @keyup="CheckAvailable(data), CheckRequestQty(data)" />
                        </div>
                    </template>
                    <template v-slot:Reason="{ data, rowIndex }">
                        <div class="label-d-none tablefield mb-0">
                            <InputText :rules="{ required: true }" :required-icon="false" :name="`'Reason'${rowIndex}`"
                                :class="{ disableclass: data.disabled == true }" :id="`'Reason'${rowIndex}`"
                                v-model="data.PickReason" />
                        </div>
                    </template>
                    <template v-slot:Remarks="{ data, rowIndex }">
                        <div class="label-d-none tablefield mb-0">
                            <InputText :rules="{ required: false }" :required-icon="false"
                                :class="{ disableclass: data.disabled == true }" :name="`'Remarks'${rowIndex}`"
                                :id="`'Remarks'${rowIndex}`" v-model="data.Remarks" />
                        </div>
                    </template>
                </Tableview>
            </div>
            <div class="d-flex flex-row-reverse">
                <Save v-if="!StartButtonFlag" label="Cancel" size="lg" @savebtn="CancelButton">
                </Save>
                <Save v-if="!StartButtonFlag" label="Confirm & Proceed" size="lg" @savebtn="nextpage">
                </Save>
                <Save v-if="StartButtonFlag" label="Start" size="lg" @savebtn="StartButton">
                </Save>
            </div>
        </b-container>
    </div>
    <div v-else>
        <PickListTableView :ItemList="selectedProduct" :DataValues="DataValues"
            @ClosePick="DataValues.IsPickList = true, getPickListData(1)" :requestForm="requestForm" />

    </div>

    <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
        @closepopup="hidepopup" />

    <EditConfirmation :Editmodel="StartConfirmationFlag" @yes="ConfirmEditContent" @no="StartConfirmationFlag = false"
        :content="EditContent" :HeaderContent="HeaderContent" />

    <AlreadyExist :selectedcontent="selectedcontent" :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />

    <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, onUnmounted } from "vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Save from "../../../../../../components/GeneralButtons/SaveButton.vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import ConfirmationTab from "../../../../../../components/FormComponents/CancelConfirmation.vue";
import { useI18n } from "vue-i18n";
// import router from "@/router";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import WithoutStockService from "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { AnyARecord } from "dns";
import moment from "moment";
import PickListTableView from "./PickListTableView.vue";
import { useToast } from "primevue/usetoast";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import Itemservice from "../../../../Service/ItemMasService";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";


export default defineComponent({
    components: {
        BacktoPage,
        Save,
        ConfirmationTab,
        Tableview,
        PickListTableView,
        TextField,
        CrystalReportPrintPopUp,
        Footer,
        EditConfirmation,
        AlreadyExist
    },

    setup() {
        const { t } = useI18n();
        const confirmpopview = ref(false);
        const route = useRoute();
        const items: any = ref([]);
        const OrgItems: any = ref([]);
        const toast = useToast();
        let session: any = localStorage.getItem("UsersData");

        session = JSON.parse(session);
        let HospitalId = Number(session.OrganizationId);
        let BranchId = Number(session.BranchId);
        let UserId = Number(session.UserId);

        let QueryStringValue2: any = route.query;
        QueryStringValue2 = JSON.parse(QueryStringValue2.data);

        let StartButtonFlag = ref(true)
        let PrintButtonFlag = ref(false)
        let StartConfirmationFlag = ref(false)
        let EditContent = ref('')
        let HeaderContent = ref('')
        const CrystalReportPopup = ref(false);
        const ParameterValues = ref({
            Id: 0,
        });

        const PrintType = ref({
            Type: "T",
            FormId: 71,
            HeaderTitle: "Pickup List",
            ModuleId: 3,
        });


        const headers = [
            {
                header: "Category",
                field: "ItemCategory1",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth newcolumnfreezeleft1"

            },
            {
                header: "Code",
                field: "ItemProductId",
                class: "smallwidth newcolumnfreezeleft2",
                bodyclass: "boldclass",
            },
            {
                header: "Name",
                field: "Itemname1",
                slot: "Itemname1",
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: "boldclass text_overflow2",
                class: "mediumwidth newcolumnfreezeleft3",
            },
            {
                header: "Exp date",
                field: "ExpiryDate",
                slot: "ExpiryDate",
                class: "smallwidth newcolumnfreezeleft4",
                sortable: false,
                fieldDisplay: "false",
            },
            {
                header: "UOM",
                field: "UOMName",
                slot: "UOMName",
                filterTemplate: "MultiSelect",
                class: "smallwidth",
                ShowMactchMode: false,
                fieldDisplay: "false",
            },
            {
                header: "Batch.No",
                field: "BatchNo",
                slot: "BatchNo",
                filterTemplate: "MultiSelect",
                class: "smallwidth",
                ShowMactchMode: false,
                fieldDisplay: "false",
            },

            {
                header: "Avl Qty",
                field: "StockInHand",
                slot: 'StockInHand',
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                bodyclass: "right_td",
            },
            {
                header: "Issued Qty ",
                field: "IssuedQuantity",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                bodyclass: "right_td",
            },
            {
                header: "Qty",
                field: "RequestedQty",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                bodyclass: "right_td",
            },
            {
                header: "Pick Qty",
                field: "PickQty",
                slot: 'PickQty',
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                class: "smallwidth",
                bodyclass: "right_td",
            },
            {
                header: "Reason",
                field: "Reason",
                slot: 'Reason',
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                class: "mediumwidth",
                ShowMactchMode: false,
            },
            {
                header: "Remarks",
                field: "Remarks",
                slot: 'Remarks',
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                class: "mediumwidth",
                ShowMactchMode: false,
            },

            {
                header: "Bin Location",
                field: "RoomName",
                slot: 'BinLocation',
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('storetabdetails.outboundrequestdetails.Brand/Model/Size'),
                field: "",
                slot: "Brandmodelsize",
                fieldDisplay: "false",
                bodyclass: "text_overflow1",
            },
        ];

        const globalFilterFields = ref(headers.map((col) => col.field));
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            TaxName: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxType: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TaxSubType: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
            ActiveStatus: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
        };

        const confirmpop = () => {
            debugger;
            confirmpopview.value = true;
        }
        const closetrigger = async () => {
            confirmpopview.value = false;
        }

        const validateSelection = () => {
            if (selectedProduct.value.length === 0) {
                toast.add({
                    severity: "warn",
                    summary: "Please Select the Item",
                    detail: "",
                    life: 3000,
                });
                return false;
            }
            if (selectedProduct.value.some((i1) => i1.StockInHand === 0)) {
                toast.add({
                    severity: "warn",
                    summary: "Pick Quantity must be less than Available Quantity",
                    detail: "",
                    life: 3000,
                });
                return false;
            }
            return true;
        }; const alreadyexistpop = ref(false);
        let afterSave = ref(false)
        let selectedcontent = ref("Some items are already picked")

        const nextpage = async () => {
            DataValues.value.IsPickList = false;
        };

        const requestForm = ref({
            requestId: "",
            StockWOTransTMId: 0,
            StockOutTMId: 0,
            fromStoreId: ref(),
            fromStoreName: "",
            toStoreId: ref(),
            toStoreName: "",
            issueId: "",
            issueReturnId: "",
            status: 0,
            type: 0,
            StockInTransId: 0,
            Types: 0,
            fromStoreCode: "",
            toStoreCode: "",
            EntityId: 0,
            EntityOperationId: 0,
            RequestCreatedBy: 0,
            RequestCreatedBranch: 0
        });

        const CategoryList: any = ref([]);
        const selectedProduct: any = ref([]);
        const DataValues = ref({
            StoreName: "",
            StoreType: "",
            TotalSelected: ref(),
            TimeStart: false,
            IsPickList: true,
            StoreId: 0,
            PickTime: "",
            Disabled: ref('false')
        });

        /*---Method ---*/
        DataValues.value.TotalSelected = computed(() => {
            let data = selectedProduct.value.length + "/" + items.value.length;
            return data;
        });

        //Category click
        const SelectCategories = (data) => {
            debugger;
            if (data.selected) {
                data.bgColor = 'greybg'
                data.selected = false
                selectedProduct.value = selectedProduct.value.filter((item) => item.CategoryId != data.CategoryId)
            }
            else {
                data.bgColor = 'bluebg'
                data.selected = true
            }
            let arr = CategoryList.value.filter((item) => item.selected == true).map((it1) => it1.CategoryId);
            if (arr.length == 0) {
                items.value = OrgItems.value;
            }
            else {
                items.value = OrgItems.value.filter((item) => arr.includes(item.CategoryId));
                selectedProduct.value = items.value;
            }
        }
        onMounted(() => {
            debugger;

            const data = route.query.data as string;
            const requestform1 = JSON.parse(data);
            requestForm.value.EntityOperationId = requestform1["OperationId"];
            requestForm.value.EntityId = requestform1["EntityId"];
            requestForm.value.Types = requestform1["Types"];
            requestForm.value.StockInTransId = requestform1["StockTransId"];
            requestForm.value.issueId = requestform1["issueId"] ?? "";
            requestForm.value.issueReturnId = requestform1["issueReturnId"] ?? "";
            requestForm.value.StockWOTransTMId = requestform1["StockWOTransTMId"];
            requestForm.value.StockOutTMId = requestform1["StockOutTransTMId"];
            requestForm.value.status = requestform1["status"];
            requestForm.value.type = requestform1["type"];
            requestForm.value.requestId = requestform1["requestId"];
            requestForm.value.fromStoreId = requestform1["fromStoreId"];
            requestForm.value.toStoreId = requestform1["toStoreId"];
            requestForm.value.toStoreName = requestform1["toStoreName"];
            requestForm.value.StockInTransId = requestform1?.["StockTransId"];
            StartTime.value = moment().format("YYYY-MM-DDTHH:mm:ss.SSS")
            getPickListData(1);
        });
        let StartTime = ref()
        const ItemsListAll: any = ref([]);
        //Get the Pick List Data
        async function getPickListData(Type) {
            debugger
            try {

                const result = await WithoutStockService.GetPickListByRequestId(
                    requestForm.value.StockWOTransTMId, HospitalId, QueryStringValue2["BranchId"]
                );
                console.log(result["result"]);
                requestForm.value.RequestCreatedBy = result["result"][0]?.CreatedBy;
                requestForm.value.RequestCreatedBranch = result["result"][0]?.BranchId;
                ItemsListAll.value = result["result"].map((i1) => {
                    i1.ApprovedQty = i1.ItemQuantity
                    i1.PickQuantity = i1.ItemQuantity;
                    i1.PickStartTime = (i1.PickStartTime == '1900-01-01 00:00:00.0000000') ? '' : i1.PickStartTime
                    i1.PickEndTime = (i1.PickEndTime == '1900-01-01 00:00:00.0000000') ? '' : i1.PickEndTime
                    i1.IsScanned = (i1.PickStatus == 3) ? 1 : 0;
                    i1.disabled = false;
                    i1.StoreId = requestForm.value.fromStoreId;
                    i1.HospitalId = HospitalId;
                    i1.StockStatus = 3;
                    return i1;
                });
                OrgItems.value = ItemsListAll.value.filter((i1) => i1.PickedBy == 0 || i1.PickedBy == UserId);
                DataValues.value.StoreName = OrgItems.value[0]?.StoreName || "";
                DataValues.value.StoreType = OrgItems.value[0]?.StoreType || "";
                DataValues.value.StoreId = OrgItems.value[0]?.ToStore || 0;

                let AlreadyPickList: any = OrgItems.value.filter((item) => item.PickedBy == UserId);
                if (AlreadyPickList.length > 0) {
                    items.value = OrgItems.value.map((item, index) => {
                        item.serialnumber = index
                            ,
                            item.disabled = Type == 1 ? true : false
                        return item;
                    });
                    selectedProduct.value = AlreadyPickList.map((item) => {
                        item.disabled = true
                        return item;
                    });;
                    StartButtonFlag.value = false
                    PrintButtonFlag.value = true
                    DataValues.value.Disabled = 'true'
                }
                else {
                    items.value = OrgItems.value.filter((i1) => i1.PickedBy == 0);
                    selectedProduct.value = OrgItems.value.filter((item) => item.PickedBy == 0);
                }
                CategoryList.value = OrgItems.value.reduce((acc: any, current) => {
                    const { CategoryId, ItemCategory1, PickedBy }: any = current;
                    const existingCategory: any = acc.find(item => item["CategoryId"] == CategoryId);
                    if (existingCategory) {
                        existingCategory.count++;
                    } else {
                        let bgColor = 'bluebg';
                        let selected = true;
                        let disabled = false;

                        if (PickedBy != UserId && PickedBy != 0) {
                            bgColor = 'orangebg disableclass';
                            selected = false;
                            disabled = true
                        }
                        else if (PickedBy == 0 && AlreadyPickList.length > 0) {
                            bgColor = 'greybg';
                            selected = false;

                        }
                        acc.push({ CategoryId, ItemCategory1, count: 1, bgColor: bgColor, selected: selected, disabled: disabled });
                    }
                    return acc;
                }, []);
            }
            catch (error) {

            }
        }
        //Update Picks-common function
        async function UpdatePicks(PickStatus, Type) {
            debugger
            let arr: any = [];
            let checkstockAvailabilityresult: any;
            let hasStockStatusOneOrTwo: any;
            let hasStockStatusZeroOrOne: any;


            if (Type == 1) {
                debugger
                checkstockAvailabilityresult = await Itemservice.CheckstockAvailability(
                    selectedProduct.value.filter((items) => items.disabled == false)
                );
                debugger
                hasStockStatusOneOrTwo = checkstockAvailabilityresult['result'].some(
                    (item) => item.StockStatus === 1 || item.StockStatus === 2
                );
                hasStockStatusZeroOrOne = checkstockAvailabilityresult['result'].some(
                    (item) => item.StockStatus === 0 || item.StockStatus === 1
                );
                debugger
                selectedProduct.value.forEach((item) => {
                    const stockItem = checkstockAvailabilityresult['result'].find(
                        (s) =>
                            s.ItemId === item.ItemId &&
                            s.Brand === item.Brand &&
                            s.ModelNumber === item.ModelNumber &&
                            s.Size === item.Size
                    );

                    if (stockItem) {
                        item.StockStatus = stockItem.StockStatus;
                        item.PickQuantity =
                            stockItem.StockStatus === 1
                                ? stockItem.StockInHand
                                : stockItem.StockStatus === 0
                                    ? 0
                                    : item.PickQuantity;
                    }
                });

                if (hasStockStatusOneOrTwo) {
                    for (let i = 0; i < selectedProduct.value.length; i++) {
                        let obj: any = {};
                        obj.PickTime = StartTime.value;
                        obj.PickStatus = PickStatus;
                        obj.Type = Type;
                        obj.ItemId = Number(selectedProduct.value[i].ItemId);
                        obj.BarCodeNo = Number(selectedProduct.value[i].BarCodeNo);
                        obj.BarCode = selectedProduct.value[i].BarCode || "";
                        obj.StockWoDetailsId = Number(selectedProduct.value[i].StockDetailsId);
                        obj.PickedBy = UserId
                        obj.PickQuantity = Number(selectedProduct.value[i].PickQuantity);
                        obj.PickReason = String(selectedProduct.value[i].PickReason);
                        obj.Remarks = String(selectedProduct.value[i].Remarks);
                        arr[i] = obj;
                    }
                    const result = await WithoutStockService.UpdatePickStatus(
                        arr
                    );
                    if (hasStockStatusZeroOrOne) {
                        alreadyexistpop.value = true;
                        afterSave.value = true

                    }
                    debugger
                }
                else {
                    alreadyexistpop.value = true;
                    afterSave.value = true
                }

            }
            else {
                for (let i = 0; i < selectedProduct.value.length; i++) {
                    let obj: any = {};
                    obj.PickTime = StartTime.value;
                    obj.PickStatus = PickStatus;
                    obj.Type = Type;
                    obj.ItemId = Number(selectedProduct.value[i].ItemId);
                    obj.BarCodeNo = Number(selectedProduct.value[i].BarCodeNo);
                    obj.BarCode = selectedProduct.value[i].BarCode || "";
                    obj.StockWoDetailsId = Number(selectedProduct.value[i].StockDetailsId);
                    obj.PickedBy = UserId
                    obj.PickQuantity = Number(selectedProduct.value[i].PickQuantity);
                    obj.PickReason = String(selectedProduct.value[i].PickReason);
                    obj.Remarks = String(selectedProduct.value[i].Remarks);
                    arr[i] = obj;
                }
                const result = await WithoutStockService.UpdatePickStatus(
                    arr
                );
                debugger
            }

            debugger;
        }
        //Product Selection Change-->Category List will be selected/unselected
        function ProductSelection() {
            try {
                debugger;
                console.log(selectedProduct.value);
                CategoryList.value = CategoryList.value.map((i1) => {
                    let arr = selectedProduct.value.find((item) => item.CategoryId == i1.CategoryId);
                    if (arr) {
                        i1.bgColor = 'bluebg'
                        i1.selected = true
                    }
                    else {
                        i1.bgColor = 'greybg'
                        i1.selected = false
                    }
                    return i1;
                })
            }
            catch (error) {

            }
        }
        //Check The Pick Quantity With StockIn
        function CheckAvailable(data) {
            debugger;
            if (Number(data.PickQuantity) < 0) {
                data.PickQuantity = '0'
                return
            }

            const { RequestedQty, ItemId, Size, Brand, ModelNumber } = data;

            // Calculate total pick quantity for matching items
            const totalPickQuantity = items.value
                .filter(item => item.ItemId === ItemId && item.Size === Size && item.Brand === Brand && item.ModelNumber === ModelNumber)
                .reduce((sum, item) => sum + Number(item.PickQuantity), 0);

            // Exclude current item's pick quantity
            const PickQty = RequestedQty - (totalPickQuantity - Number(data.PickQuantity))
            if (Number(data.PickQuantity) > Number(data.StockInHand)) {
                toast.add({
                    severity: "warn",
                    summary: "Quantity Exceeds the Available Quantity",
                    detail: "",
                    life: 3000,
                });
                if (PickQty >= data.ItemQuantity) {
                    data.PickQuantity = data.ItemQuantity;
                }
                else {
                    data.PickQuantity = PickQty
                }
                return false;
            }
        }
        function CheckRequestQty(data) {
            debugger
            const { RequestedQty, ItemId, Size, Brand, ModelNumber } = data;

            // Calculate total pick quantity for matching items
            const totalPickQuantity = items.value
                .filter(item => item.ItemId === ItemId && item.Size === Size && item.Brand === Brand && item.ModelNumber === ModelNumber)
                .reduce((sum, item) => sum + Number(item.PickQuantity), 0);

            // Exclude current item's pick quantity
            const PickQty = totalPickQuantity - Number(data.PickQuantity);

            if (totalPickQuantity > RequestedQty) {
                toast.add({
                    severity: "warn",
                    summary: "Quantity Exceeds the Requested Quantity",
                    detail: "",
                    life: 3000,
                });
                data.PickQuantity = RequestedQty - PickQty;
                return false;
            }

            return true; // Return true if no issues
        }
        //Specify Orange color if the Item doesn't have stock
        function getColorStyle(data) {
            return data.StockInHand < data.ItemQuantity ? { color: "Orange" } : data.IsFreeItem == 1 ? { color: "Red" } : {};
        }

        function PrintOnClick() {
            debugger;
            CrystalReportPopup.value = true;
            const QueryStringValue = JSON.parse(route.query.data as string);
            ParameterValues.value.Id = QueryStringValue["StockWOTransTMId"];
        }

        const hidepopup = () => {
            CrystalReportPopup.value = false;
        };
        const Itemschanges = (value) => {
            debugger;
            if (value != "") {
                items.value = []
                items.value = value;
            }
        };
        const StartButton = () => {
            if (!validateSelection()) return;
            StartConfirmationFlag.value = true
            EditContent.value = 'Are you sure you have chosen the category items correctly?'
            HeaderContent.value = 'Confirm Start!'
        };

        const CancelButton = () => {
            StartConfirmationFlag.value = true
            EditContent.value = 'Are you sure you have chosen the category items correctly?'
            HeaderContent.value = 'Confirm Cancel!'
        };

        const ConfirmEditContent = async () => {
            StartConfirmationFlag.value = false
            if (StartButtonFlag.value) {

                await UpdatePicks(1, 1)
                PrintButtonFlag.value = true
                items.value.forEach(item => {
                    item.disabled = true;
                });
                selectedProduct.value.forEach(item => {
                    item.disabled = true;
                });
                DataValues.value.Disabled = 'true'
            }
            else {
                await UpdatePicks(1, 4)
                PrintButtonFlag.value = false
                items.value.forEach(item => {
                    item.disabled = false;
                });
                DataValues.value.Disabled = 'false'
            }
            StartButtonFlag.value = !StartButtonFlag.value

        }
        async function alreadyclosetrigger() {
            debugger;
            alreadyexistpop.value = false
            await getPickListData(2);
            StartButtonFlag.value = true
        }
        return {
            Itemschanges,
            getColorStyle,
            CheckAvailable,
            CheckRequestQty,
            ProductSelection,
            selectedProduct,
            getPickListData,
            items,
            SelectCategories,
            filters,
            globalFilterFields,
            confirmpopview,
            headers,
            confirmpop,
            closetrigger,
            nextpage,
            CategoryList,
            DataValues,
            requestForm,
            UpdatePicks,
            CrystalReportPopup,
            ParameterValues,
            PrintType,
            hidepopup,
            PrintOnClick,
            CancelButton,
            StartButtonFlag,
            StartButton,
            StartConfirmationFlag,
            ConfirmEditContent,
            EditContent,
            HeaderContent,
            alreadyexistpop,
            afterSave,
            selectedcontent,
            alreadyclosetrigger,
            PrintButtonFlag
        }
    }
})
</script>
<style scoped>
.nav-bar {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.3);
}

.body-heading {
    font-size: 22px;
}

.category-name {
    width: fit-content;
    padding: 8px 30px 8px 30px;
    margin: 1% 2% 1% 2%;
    border-radius: 33px;
    background-color: #8080803b;
}

.greybg {
    background-color: #8080803b
}

.bluebg {
    background-color: #137bd53b
}

.orangebg {
    background-color: #e66d353b
}

.print-button {
    width: 15px;
}

.categories {
    width: 100%;
    /* border: 1px solid black; */
}

.count {
    background-color: black;
    color: white;
    width: 180px;

}

.medicine,
.total_count {
    border-bottom: 1px solid grey;
}


.number {
    padding: 3%;
    font-weight: 800;
}


.count2,
.count {
    display: grid;
    align-content: center;
}

.count2 {
    border-right: 1px solid grey;
}

.blue {
    background-color: rgb(0 131 255);
    font-weight: 400 !important;
    color: white;
    padding: 5% 14%;
    border-radius: 50%;
}

.count-section {
    background-color: rgb(207, 207, 207);

}

.selected {
    background-color: rgb(0 131 255) !important;
    color: white !important;
}

/* .timer {
    display: flex;
    flex-direction: row;
    max-width: 80%;
    justify-content: center;
    align-items: center;
    background-color: black;
    color: white;
} */


.d-dlex.timer {
    width: max-content;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: black;
    color: white;
    border-radius: 28px;
}

.Items,
.timerWatch {
    padding: 24px 20px;
    width: 300px;
}

.timerdiv {
    border: 1px solid #e1e1e1;
    border-radius: 10px;
    padding: 10px;
    width: max-content;
}

.timerWatch img {
    width: 19px;
    height: 12px;
}

.navbar {
    justify-content: space-evenly;
}

.disableclass {
    pointer-events: none;
    opacity: 0.5;
}
</style>
<!-- /* Am active */

box-sizing: border-box;

/* Auto layout */
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 20px 16px;
gap: 14px;

position: relative;
width: 279px;
height: 124px;
background: #000000;
    border: 1px solid #303132; -->

<style lang="scss">
// .tablefield .inputtext{
//     width:50% !important;
// }</style>
